module.exports = __webpack_public_path__ + "static/tax-investigation-717b624c9a8747076c97df74174db066.svg";